import React from 'react';

const Header = () => {
  return (
    <div className="bg-dark text-light text-center py-1">
        <h2>Contact Manager</h2>
    </div>
  );
}

export default Header;